import React from 'react';
import withNuiIntl from '../utils/withNuiIntl';
import compose from '../utils/compose';
import withStylesLoaded from '../utils/withStylesLoaded';
import MiniHeader from './_MiniHeader';

// this wrapper component is necessary to wrap the component
// in a ThemeProvider (handled in withStylesLoaded)
const AppMiniHeader = (props) => <MiniHeader {...props} />;

AppMiniHeader.displayName = 'AppMiniHeader';

AppMiniHeader.propTypes = {
    ...MiniHeader.propTypes,
};

export default compose(
    withStylesLoaded,
    withNuiIntl,
)(AppMiniHeader);
